import { pxToRem } from 'utils/convert';
import { FileType } from '../../types';
import { Product, Team } from 'teams';

export const CREATIVE_LIBRARY_COLUMN_IDS = {
  NAME: 'Name',
  UPDATED_AT: 'UpdatedAt',
  SIZE: 'Size',
  TYPE: 'Type',
};

export const CREATIVE_LIBRARY_COLUMNS = [
  { id: CREATIVE_LIBRARY_COLUMN_IDS.NAME, label: 'Name' },
  { id: CREATIVE_LIBRARY_COLUMN_IDS.UPDATED_AT, label: 'Last modified' },
  { id: CREATIVE_LIBRARY_COLUMN_IDS.SIZE, label: 'Size' },
  { id: CREATIVE_LIBRARY_COLUMN_IDS.TYPE, label: 'Type' },
];

export const TABLE_GRID = `
  ${pxToRem(42)} // select checkbox
  minmax(${pxToRem(220)}, 1fr) // name
  ${pxToRem(220)} // last modified
  ${pxToRem(220)} // size
  ${pxToRem(200)} // type
  ${pxToRem(36)}  // overflow menu button
`;

export const FILE_TYPE_FILTERS: Record<string, string>[] = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'PNG',
    value: FileType.PNG,
  },
  {
    label: 'JPEG',
    value: FileType.JPEG,
  },
  {
    label: 'GIF',
    value: FileType.GIF,
  },
];

export const CREATIVE_LIBRARY_RUM_ATTRIBUTES = {
  teamName: Team.CONTENT_TEAM,
  productName: Product.CREATIVE_LIBRARY,
};
